import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Solution(props) {
    return (
        <div className="services_solution  p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <div className="example" data-text="Engineer">
                            <h2>Engineer The Best Product With Minimal Wasteful Efforts</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
                      <p>The lean startup strategy involves utilizing agile and MVP development techniques, ensuring more directed efforts and less time wasted. With continuously evolving and changing requirements, all low-level tasks are replaced with those essential for a smooth development process</p>
                        <p>Our digital experts keep their prime focus on making functionalities as relevant and meaningful as possible with little to no emphasis on scalability. All the design and development operations get expedited through short sprints and quick peer reviews.</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>

                </Row>
            </Container>
        </div>
    );
}

export default Solution;